import { NoticeFactory } from '@b2b/common/factories/notice';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { TODO } from '@b2b/types/core/utils';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

LoginTokenController.$inject = ['$scope', '$state', 'AuthService', 'NoticeFactory', 'AuthenticationService'];
function LoginTokenController(
  $scope: IScope & { loginToken: TODO },
  $state: StateService,
  AuthService: TODO,
  NoticeFactory: NoticeFactory,
  authenticationService: AuthenticationService,
) {
  const ctrl = {
    notice: new NoticeFactory(),

    init: function () {
      console.log('LoginTokenController::init');

      authenticationService
        .logout()
        .then(() => ctrl.logout())
        .catch(() => ctrl.logout());

      ctrl.notice = new NoticeFactory();
    },

    complete: function () {
      ctrl.notice.hideMessages();
      ctrl.notice.startLoad();

      if ($state.params && $state.params.hasOwnProperty('token')) {
        ctrl.notice.startLoad();

        AuthService.confirm({ token: $state.params.token })
          .then((response) => ctrl.success.complete(response))
          .catch((response) => ctrl.error.complete(response));
      }
    },

    logout: function () {
      console.log('LoginTokenController::logout -> Killin cookies');
      ctrl.complete();
    },

    success: {
      complete: function (...response) {
        ctrl.notice.endLoad();
        $scope.$emit('LoginTokenController::login::success', response);
      },
    },

    error: {
      complete: function (response) {
        ctrl.notice.endLoad();
        ctrl.notice.showErrorMessages([{ message: 'There was a problem: ' + response.data.error }]);
      },
    },
  };

  $scope.loginToken = ctrl;
  ctrl.init();
}

export const LoginTokenControllerModule = angular
  .module('acme.view.login.controllers.loginToken', [
    uiRouter,
    'acme.common.service.auth',
    'acme.common.factory.notice',
    AuthenticationServiceModule,
  ])
  .controller('LoginTokenController', LoginTokenController).name;
